import type { JSX } from "react";
import { useEffect, useRef } from "react";
import { mountEngine } from "../state/engine/engine.actions.ts";
import { themeState } from "../state/theme/theme.state.ts";
import { HudOverlay } from "./HudOverlay.tsx";
import { LegSelection } from "./LegSelection.tsx";

/**
 * Hosts the three.js canvas.
 *
 * The dock detaches panel content rather than destroying it, so the WebGL
 * context survives collapsing, tab switches and re-docking; the engine is
 * mounted once for the life of the panel.
 */
export function ViewportPanel(): JSX.Element {
  const hostRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const host = hostRef.current;
    if (!host) {
      return;
    }

    return mountEngine(host, themeState.get().theme);
  }, []);

  return (
    <div className="relative h-full w-full overflow-hidden">
      <div ref={hostRef} className="h-full w-full" />
      <HudOverlay />
      <LegSelection />
    </div>
  );
}
